import { Map } from 'immutable';

import * as t from '../../actions/accountSettingsActionTypes';

const initialState = Map({
  isLoadingResetAll: false,
  isLoadingResetIndividualQuestion: false,
  isLoadingDisabledQuestions: false,

  successResetAll: false,
  successResetIndividualQuestion: false,
  successDisabledQuestions: false,

  disabledQuestions: [],
  favoriteQuestions: [],
  listAllFavoriteQuestions: [],
  disabledQuestionsCount: 0,
  favoriteQuestionsCount: 0,

  loadingRemoveFavoriteQuestions: false,
  loadingFavoriteQuestions: false,

  submittedQuestions: [],
  isLoadingSubmittedQuestions: false,
});

const reducer = function disabledQuesitonsReducer(
  state = initialState,
  action,
) {
  switch (action.type) {
    case t.IS_LOADING_GET_DISABLED_QUESTIONS:
      return state.set('isLoadingDisabledQuestions', action.isLoading);

    case t.IS_LOADING_RESET_ALL_DISABLED_QUESTIONS:
      return state.set('isLoadingResetAll', action.isLoading);

    case t.IS_LOADING_RESET_DISABLED_INDIVIDUAL_QUESTION:
      return state.set('isLoadingResetIndividualQuestion', action.isLoading);

    case t.SUCCESS_GET_DISABLED_QUESTIONS:
      return state.set('successDisabledQuestions', action.success);

    case t.SUCCESS_RESET_ALL_DISABLED_QUESTIONS:
      return state.set('successResetAll', action.success);

    case t.SUCCESS_RESET_DISABLED_INDIVIDUAL_QUESTION:
      return state.set('successResetIndividualQuestion', action.success);

    case t.SET_DISABLED_QUESTIONS:
      return state.set(
        'disabledQuestions',
        state.get('disabledQuestions').concat(action.questions),
      );

    case t.SET_FAVORITE_QUESTIONS:
      return state.set(
        'favoriteQuestions',
        state.get('favoriteQuestions').concat(action.questions),
      );

    case t.REMOVE_FAVORITE_QUESTION:
      const newFavoriteQuestions = [];
      state.get('favoriteQuestions').forEach((question) => {
        if (question.id !== action.questionId) {
          newFavoriteQuestions.push(question);
        }
      });
      return state
        .set('favoriteQuestions', newFavoriteQuestions)
        .set('favoriteQuestionsCount', state.get('favoriteQuestionsCount') - 1);

    case t.SET_ALL_FAVORITE_QUESTIONS:
      return state.set('listAllFavoriteQuestions', action.questions);

    case t.LOADING_REMOVE_FAVORITE_QUESTIONS:
      return state.set('loadingRemoveFavoriteQuestions', action.isLoading);
    case t.LOADING_GET_FAVORITE_QUESTIONS:
      return state.set('loadingFavoriteQuestions', action.isLoading);

    case t.SET_DISABLED_QUESTIONS_COUNT:
      return state.set('disabledQuestionsCount', action.count);

    case t.SET_FAVORIE_QUESTIONS_COUNT:
      return state.set('favoriteQuestionsCount', action.count);

    case t.REMOVE_QUESTION_FROM_LIST:
      const disabledQuestions = state.get('disabledQuestions');
      const newDisabledQuestions = [];
      disabledQuestions.forEach((question) => {
        if (question.id !== action.questionId) {
          newDisabledQuestions.push(question);
        }
      });
      return state
        .set('disabledQuestions', newDisabledQuestions)
        .set('disabledQuestionsCount', action.newCount);

    case t.RESET_DISABLED_QUESTIONS_OBJECT:
      return state.set('disabledQuestions', []);

    case t.RESET_FAVORITE_QUESTIONS_OBJECT:
      return state.set('favoriteQuestions', []);

    default:
      return state;
  }
};

export default reducer;
